import { render, staticRenderFns } from "./messageNotifications.vue?vue&type=template&id=601039d7&scoped=true&"
import script from "./messageNotifications.vue?vue&type=script&lang=ts&"
export * from "./messageNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./messageNotifications.vue?vue&type=style&index=0&id=601039d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601039d7",
  null
  
)

export default component.exports